export default __webpack_public_path__ + "dd6389d803566161cddc42f7d0c8cd94.svg";